import React from 'react'
import { Helmet } from 'react-helmet-async'

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = 'Supreme Overseas'
    const defaultDescription = 'Leading study abroad consultants helping students achieve their dreams of international education.'
    const defaultImage = '/LOGO%20NAVABAR%20FOOTER/SO%20-%20Replace%202%20(1).png'
    const siteUrl = 'https://supremeoverseas.com'

    const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle
    const metaDescription = description || defaultDescription
    const metaImage = image || defaultImage
    const metaUrl = url ? `${siteUrl}${url}` : siteUrl

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={metaUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={metaUrl} />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />
        </Helmet>
    )
}

export default SEO
